<template>
  <div>
    <el-dialog :title="this.value.isCreate ? '添加分区' : '修改分区'" center :visible.sync="visible" @closed="onClosed"
      :close-on-click-modal="false" :close-on-press-escape="false" width="550px">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" size="mini" style="width:400px">
        <el-form-item label="ID" prop="id">
          <el-input v-model.number="form.id" :disabled="!value.isCreate"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="合入到哪个分区" prop="mergedIntoZoneId" v-if="!value.isCreate">
          <el-input v-model.number="form.mergedIntoZoneId" placeholder="没有的话就不用填" clearable style="width:130px"></el-input>
        </el-form-item>
        <el-form-item label="对外地址（http）" prop="address" v-if="form.mergedIntoZoneId == ''">
          <el-input v-model="form.address" placeholder="举例：https://api.example.com/z1"></el-input>
        </el-form-item>
        <el-form-item label="对内地址（grpc）" prop="internalAddress" v-if="form.mergedIntoZoneId == ''">
          <el-input v-model="form.internalAddress" placeholder="举例：localhost:11002"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择" style="width:130px">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
export default {
  data() {
    return {
      visible: true,
      form: {
        id: "",
        name: "",
        address: "",
        internalAddress: "",
        status: "",
        mergedIntoZoneId: "",
      },
      rules: {
        id: [{ type: 'number', required: true, message: " ", trigger: "blur" }],
        name: [{ required: true, message: " ", trigger: "blur" }],
        address: [{
          validator: (rule, value, callback) => {
            if (this.form.mergedIntoZoneId.trim() != "") {
              callback();
            } else {
              if (value.trim() == "") {
                callback(new Error("不能为空"));
              } else {
                callback();
              }
            }
          }, trigger: "blur"
        }],
        internalAddress: [{
          validator: (rule, value, callback) => {
            if (this.form.mergedIntoZoneId.trim() != "") {
              callback();
            } else {
              if (value.trim() == "") {
                callback(new Error("不能为空"));
              } else {
                callback();
              }
            }
          }, trigger: "blur"
        }],
      },
      statusOptions: [
        {
          value: 0,
          label: "隐藏",
        },
        {
          value: 1,
          label: "维护",
        },
        {
          value: 2,
          label: "流畅",
        },
        {
          value: 3,
          label: "爆满",
        },
      ],
    };
  },

  props: {
    value: Object,
  },

  created() {
    if (!this.value.isCreate) {
      this.form.id = this.value.oldData.id;
      this.form.name = this.value.oldData.name;
      this.form.address = this.value.oldData.address;
      this.form.internalAddress = this.value.oldData.internalAddress;
      this.form.status = this.value.oldData.status;
      this.form.mergedIntoZoneId = this.value.oldData.mergedIntoZoneId == 0 ? "" : this.value.oldData.mergedIntoZoneId;
    } else {
      this.form.status = 0; // 默认“下线”状态
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.addZone();
      } else {
        this.updateZone();
      }
    },

    /**
     * 新增分区
     */
    addZone() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let zoneId = parseInt(this.form.id);
        if (zoneId.toString() != this.form.id || zoneId <= 0) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addZone`,
            {
              zone: {
                id: zoneId,
                name: this.form.name,
                address: this.form.address,
                internalAddress: this.form.internalAddress,
                status: this.form.status,
              },
            },
            {
              headers: {
                token: util.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    /**
     * 修改分区
     */
    updateZone() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let mergedIntoZoneId = 0;
        if (this.form.mergedIntoZoneId != "") {
          mergedIntoZoneId = parseInt(this.form.mergedIntoZoneId);
          if (mergedIntoZoneId.toString() != this.form.mergedIntoZoneId || mergedIntoZoneId < 0 || mergedIntoZoneId == this.form.id) {
            this.$alert("请检查输入", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        }

        let address = this.form.address;
        let internalAddress = this.form.internalAddress;
        if (mergedIntoZoneId > 0) {
          address = "";
          internalAddress = "";
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateZone`,
            {
              zone: {
                id: this.value.oldData.id,
                name: this.form.name,
                address: address,
                internalAddress: internalAddress,
                status: this.form.status,
                mergedIntoZoneId: mergedIntoZoneId,
              },
            },
            {
              headers: {
                token: util.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>